<template>
  <div class="order-detail-wrap" v-if="orderInfo">
    <header class="detail-head">
      <p class="detail-head-status">
        <i :class="['DHS-icon', orderInfo.statusCode]"></i>
        <span class="DHS-text">{{ orderInfo.statusName }}</span>
      </p>
    </header>
    <div class="detail-product block">
      <img :src="handleImgHead(orderInfo.picUrls)" alt="" class="detail-product-icon">
      <div class="detail-product-info">
        <div class="black-font">
          <span>{{ orderInfo.productName }}</span>
          <span>￥{{ (orderInfo.salePrice * 1).toFixed(2) }}</span>
        </div>
        <div class="grey-font">
          <span>{{ orderInfo.skuName }}</span>
          <!-- <span>X{{ orderInfo.num }}</span> -->
        </div>
      </div>
    </div>
    <ul class="detail-list block">
      <li class="detail-list-item">
        <span>充值账号</span>
        <span>{{ orderInfo.target }}</span>
      </li>
      <li class="detail-list-item">
        <span>商品金额</span>
        <span>{{ '￥' + (orderInfo.salePrice * 1).toFixed(2) }}</span>
      </li>
      <li class="detail-list-item">
        <span>优惠金额</span>
        <span>{{ '￥' + orderInfo.schemeDiscount }}</span>
      </li>
       <li class="detail-list-item">
        <span>实付金额</span>
        <span class="price" >{{ '￥' + orderInfo.dealPrice }}</span>
      </li>
    </ul>
    <ul class="detail-order-list block">
      <li>订单编号：{{ orderInfo.orderNo }}</li>
      <li>下单时间：{{ orderInfo.createTime }}</li>
      <li>支付方式：{{ orderInfo.payMethodCode }}</li>
    </ul>
  </div>
</template>

<script>

  import Api from '../service/api'
  import Store from '../utils/store'
  export default {
    data () {
      return {
        orderInfo: null
      }
    },
    mounted () {
      const tradeId = this.$route.query.tradeId || ''
      tradeId && this.getOrderDetail(tradeId) 
    },
    methods: {
       handleImgHead (url) {
        return Api.imgHeadUrl + url
      },
      getOrderDetail (tradeId) {
        const { token: authToken , userId: loginUserId } = Store.userInfo
        this.$http.getOrderDetail({
          tradeId,
          loginUserId,
          authToken
        }).then(({data}) => {
          if (data.success) {
            this.orderInfo = data.datas
          } else {
            this.$tip('数据异常，请稍后重试')
            this.$router.back()
          }
        })
      },
    }
  }
</script>

<style lang="scss" scoped>
.block {
  width: 1042px;
  border-radius: 12px;
  background-color: #fff;
  margin: 0 auto;
  margin-top: 20px;
}
.detail-head {
  width: 100%;
  height: 211px;
  background-image: linear-gradient(-90deg, 
		#ffe49a 0%, 
    #fff2c6 100%);
  overflow: auto;
  // border: 1px solid;
  .detail-head-status {
    margin-top: 57px;
    margin-left: 48px;
    .DHS-icon {
      width: 48px;
      height: 48px;
      display: inline-block;
      vertical-align: sub;
      margin-right: 30px;
      background: url('../assets/img/order-tips.png') 0 0 / 100% 100% no-repeat;
      &.SHIPPING{
        background: url('../assets/img/order-shipping-icon.png') 0 0 / 100% 100% no-repeat; 
      }
      &.TO_BE_SHIP{
        background: url('../assets/img/order-toBeShipped-icon.png') 0 0 / 100% 100% no-repeat; 
      }
      &.REFUNDOK{
        background: url('../assets/img/order-refuned-icon.png') 0 0 / 100% 100% no-repeat; 
      }
      &.TO_BE_REFUND{
        background: url('../assets/img/order-toBeRefuned-icon.png') 0 0 / 100% 100% no-repeat; 
      }
      &.CLOSE{
        background: url('../assets/img/order-fail-icon.png') 0 0 / 100% 100% no-repeat; 
      }
      &.FINISH{
        background: url('../assets/img/order-success-icon.png') 0 0 / 100% 100% no-repeat; 
      }

    }
    .DHS-text {
      font-size: 42px;
      line-height: 40px;
    }
  }
}
.detail-product {
  display: flex;
  height: 236px;
  padding-top: 48px;
  .detail-product-icon {
    width: 145px;
    height: 145px;
    display: inline-block;
    // background: #ffe49a;
    margin-left: 45px;
    margin-right: 60px;
  } 
  .detail-product-info {
    flex: 1;
    &>div {
      display: flex;
      justify-content: space-between;
      padding-right: 40px;
    }
    .black-font {
      font-size: 42px;
      line-height: 44px;
    }
    .grey-font {
      font-size: 30px;
      line-height: 30px;
      color: #999;
      margin-top: 25px;

    }
  }
}
.detail-list {
  padding: 55px 40px;
  .detail-list-item {
    margin-bottom: 80px;
    display: flex;
    justify-content: space-between;
    font-size: 42px;
    line-height: 44px;
    &:last-child {
      margin-bottom: 0;
    }
    .price {
      font-size: 39px;
      font-weight: bold;
      color: #e70000;
    }
  } 
}
.detail-order-list {
  padding: 48px 44px;
  li {
    color: #999;
    font-size: 30px;
    line-height: 36px;
    margin-bottom: 28px;
    &:last-child {
      margin-bottom: 0;
    }
  }
}
</style>